import { values } from "lodash";

export const sensorSuppliers = [
  {
    label: 'RF Technology',
    value: 'RF Technology',
  },
  {
    label: 'Lora AirAgri',
    value: 'Lora AirAgri'
  },
  {
    label: 'Traccar AirAgri',
    value: 'Traccar AirAgri'
  },
  {
    label: 'Kinetic Solutions',
    value: 'Kinetic Solutions'
  }
]
